import CornerBg from "@/assets/img/illustrations/corner-2.png";
import ErrorComponent from "@/components/atoms/ErrorComponent";
import Loader from "@/components/atoms/Loader";
import { CardDetailsProps } from "@/interfaces/Card";
import CompanyStatus from "@/interfaces/CompanyStatus";
import { useGetCompanyStatusQuery } from "@/services/companies/statuses";

import Background from "@/components/atoms/Background";
import SoftBadge from "@/components/atoms/SoftBadge";
import classNames from "classnames";
import { DateTime } from "luxon";
import { FC, useEffect } from "react";
import { Card, Col, Form, Row } from "react-bootstrap";
import CardHeader from "../../card-headers/CardHeader";

const CompanyStatusDetailsCard: FC<CardDetailsProps<CompanyStatus>> = ({
  id,
  card,
  callBack,
}) => {
  const { data, isLoading, isError, error } = useGetCompanyStatusQuery(id);

  useEffect(() => {
    data && callBack?.(data);
  }, [data]);

  if (isLoading) {
    return <Loader absolute />;
  } else if (isError) {
    return <ErrorComponent error={error} absolute returnButton />;
  }

  return (
    <div
      className={classNames({
        card: card,
      })}
    >
      {card && <CardHeader title="Information du statut de l'entreprise" />}
      <div
        className={classNames("bg-light", {
          "card-body": card,
        })}
      >
        <Card className="border rounded-3 bg-white dark__bg-1000 shadow-none">
          <Background
            image={CornerBg}
            className="bg-card d-none d-sm-block d-xl-none"
          />
          <Card.Body className="row g-0 flex-column flex-sm-row flex-xl-column z-index-1 align-items-center">
            <Col className="ps-sm-1 ps-xl-0 d-flex justify-content-center align-items-center">
              <SoftBadge
                bg={data?.backgroundColor}
                textColor={data?.textColor}
                textClassName="h6"
                className="text-center"
              >
                {data?.name || "Inconnu"}
              </SoftBadge>
            </Col>
          </Card.Body>
        </Card>
        <Row className="border rounded-3 p-x1 mt-3 bg-white dark__bg-1000 mx-0 g-0">
          <Col md={6} xl={12} className="pe-md-4 pe-xl-0">
            <div className="mb-2">
              <Form.Label>#</Form.Label>
              <p className="mb-0 text-700 fs--1">{data!.id}</p>
            </div>
            <div className="mb-2">
              <Form.Label>Nom</Form.Label>
              <p className="mb-0 text-700 fs--1">{data!.name}</p>
            </div>
            <div className="mb-2">
              <Form.Label>Crée le</Form.Label>
              <p className="mb-0 text-700 fs--1">
                {DateTime.fromISO(data!.createdAt).toFormat("dd-MM-yyyy")}
              </p>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default CompanyStatusDetailsCard;
